//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Map from '@/assets/image/map.jpg';
import CustomDialog from '@/components/CustomDialog.vue';
import CustomDrawer from '@/components/CustomDrawer.vue';

var os = (function() {
    var ua = navigator.userAgent;
    var isWindowsPhone = /(?:Windows Phone)/.test(ua);
    var isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
    var isAndroid = /(?:Android)/.test(ua);
    var isFireFox = /(?:Firefox)/.test(ua);
    // var isChrome = /(?:Chrome|CriOS)/.test(ua);
    var isTablet =
        /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua));
    var isPhone = /(?:iPhone)/.test(ua) && !isTablet;
    var isPc = !isPhone && !isAndroid && !isSymbian;
    return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc
    };
})();

const audio = document.createElement('audio');
const media = () => {
    let oldUrl;
    return function(url) {
        if (oldUrl !== url) {
            oldUrl = url;
            audio.src = url;
            return audio;
        }
        return audio;
    };
};

export default {
    components: { CustomDialog, CustomDrawer },
    data() {
        return {
            map: '',
            level: 12,
            dialog: {
                show: false,
                content: ''
            },
            entities: [],
            os: os,
            mediaFn: media(),
            isPlayAudio: false,
            showVr: false
        };
    },
    mounted() {
        this.getEntities().then((res) => {
            if (res) {
                this.initMap();
            }
        });
    },
    methods: {
        getEntities() {
            return this.axios({
                url: '/article/listPage',
                data: {
                    categoryId: 8,
                    pageSize: 100,
                    pageNum: 1,
                    language: this.i18n
                }
            }).then((res) => {
                if (res) {
                    console.log('getEntities', res.data.data);
                    this.entities = res.data.data;
                    return true;
                }
                return false;
            });
        },
        initMap() {
            var map = window.L.map('map', {
                center: [-0.1, 0.55],
                zoom: this.level,
                minZoom: this.level,
                maxZoom: 14,
                zoomControl: false,
                scrollWheelZoom: false,
                attributionControl: false,
                maxBounds: [
                    [0, 0],
                    [-0.45, 0.8]
                ],
                bounceAtZoomLimits: false
            });
            var imageUrl = Map;
            var imageBounds = [
                [0, 0],
                [-0.45, 0.8]
            ];
            window.L.imageOverlay(imageUrl, imageBounds).addTo(map);
            this.map = map;
            this.map.on('zoomend', (eve) => {
                const level = eve.target._animateToZoom;
                var i = level - this.level;
                this.level = level;
                this.entities.forEach((item) => {
                    if (i >= 0) {
                        item.width = item.width * (+i * 2);
                        item.height = item.height * (+i * 2);
                    } else {
                        item.width = item.width / (-i * 2);
                        item.height = item.height / (-i * 2);
                    }
                    item.el.style.width = item.width / 2 + 'px';
                    item.el.style.height = item.height / 2 + 'px';
                });
            });
            this.drawEntity();
        },
        showMsg(data) {
            this.dialog.content = data;
            this.dialog.show = true;
        },
        drawEntity() {
            const div = document.createElement('div');
            for (let i = 0; i < this.entities.length; i++) {
                const e = this.entities[i];
                // 默认只显示游
                // e.x = 4889;
                // e.y = 841;
                const x = +e.x / 10000;
                const y = +e.y / 10000;
                var el = `<div class="entity" style="width: ${
                    e.width / 2
                }px; height: ${e.height / 2}px;" data-type='${
                    e.type_id
                }' data-value='${i}' x='${x}' y='${-y}';></div>`;
                div.innerHTML = el;
                el = div.firstChild;
                e.el = el;
                el.addEventListener('click', (eve) => {
                    console.log('e', e);
                    this.showMsg(e);
                    this.map.setView([-y, x]);
                });
                const myIcon = window.L.divIcon({
                    html: el
                });
                window.L.marker([-y, x], { icon: myIcon }).addTo(this.map);
                // break;
            }
        },
        overview() {
            window.open(this.dialog.content.url, 'blank');
        },
        playAudio(url, bool = undefined) {
            const audio = this.mediaFn(url);
            this.isPlayAudio = bool === undefined ? !this.isPlayAudio : bool;
            if (this.isPlayAudio) {
                audio.play().catch((e) => {
                    console.log(e);
                });
            } else {
                audio.pause();
            }
        }
    }
};
